import { lazy } from 'react'

export function isChunkLoadError(error) {
  if (!error) return false
  const msg = String(error?.message || error || '').toLowerCase()
  const name = String(error?.name || '').toLowerCase()
  return (
    name === 'chunkloaderror' ||
    msg.includes('failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('importing a module script failed') ||
    msg.includes('loading chunk') ||
    msg.includes("unexpected token '<'") ||
    msg.includes('is not valid javascript') ||
    msg.includes('is not a valid javascript') ||
    msg.includes('text/html') ||
    msg.includes('cloudflare')
  )
}

export const CHUNK_RELOAD_KEY = 'aden:chunk-reload-timestamp'
export const RELOAD_COOLDOWN_MS = 20000

export function attemptAutoReload(error) {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false
  if (!isChunkLoadError(error)) return false
  const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
  const now = Date.now()
  if (now - lastReload > RELOAD_COOLDOWN_MS) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
    if (typeof window.location?.reload === 'function') {
      window.location.reload()
      return true
    }
  }
  return false
}

export function lazyWithRetry(importer, retries = 3, interval = 400) {
  return lazy(() => {
    return new Promise((resolve, reject) => {
      function execute(attemptsLeft) {
        importer()
          .then(resolve)
          .catch(error => {
            if (attemptsLeft > 0) {
              const delay = (retries - attemptsLeft + 1) * interval
              setTimeout(() => {
                execute(attemptsLeft - 1)
              }, delay)
            } else {
              if (isChunkLoadError(error) && attemptAutoReload(error)) {
                return
              }
              reject(error)
            }
          })
      }
      execute(retries)
    })
  })
}
